import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpClient} from '@angular/common/http';

declare var device;
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
    apiUrl = environment.apiUrl;
    constructor(
        private http: HttpClient,
        private router: Router
        ) {
        }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authorization = localStorage.getItem('token') || '';
        let authReq = req.clone({
            url: `${this.apiUrl}${req.url}`,
            headers: req.headers.set('Authorization', authorization).append('tokenCC' , 'admin'),
        });
        if (authorization) {
            authReq = req.clone({
                headers: req.headers.set('Authorization', authorization).append('tokenCC' , 'admin'),
                url: `${this.apiUrl}${req.url}`,
            });
        }

        if (req.url.includes('http')) {
            return next.handle(req);
        } else {
            return next.handle(authReq).pipe(
                tap(
                    (event) => {},
                    (error) => {
                        if (error.status === '401') {
                            alert('Your current session is expired or you do not have permission for this action');
                            this.router.navigate(['signin']);
                        }
                    },
                ),
            );
        }
    }
}
